module.exports = __webpack_public_path__ + "img/accessibility_cn.40123fa.jpg";